// Import Swiper and its modules
// https://swiperjs.com/swiper-api#styles if you need to change the styles
import Swiper from 'swiper';
import {
  FreeMode,
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
} from 'swiper/modules';

// import 'swiper/css';
// import 'swiper/css/autoplay';
// import 'swiper/css/free-mode';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';

Swiper.use([Navigation, Pagination, FreeMode, Autoplay, Scrollbar]);

const imageSliderConfig = {
  grabCursor: true,
  slidesPerView: 1.1,
  spaceBetween: 16,
  watchOverflow: true,
  breakpoints: {
    768: {
      slidesPerView: 1.5,
      spaceBetween: 24,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  },
  scrollbar: {
    el: null,
    hide: false,
    draggable: true,
  },
};

const postGridSliderConfig = {
  grabCursor: true,
  slidesPerView: 1.2,
  spaceBetween: 20,
  watchOverflow: true,
  breakpoints: {
    768: {
      slidesPerView: 2.3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 32,
    },
  },
  scrollbar: {
    el: null,
    hide: false,
    draggable: true,
  },
};

const upsellsSliderConfig = {
  grabCursor: true,
  slidesPerView: 2.2,
  spaceBetween: 15,
  watchOverflow: true,
  breakpoints: {
    1025: {
      slidesPerView: 3.35,
      spaceBetween: 18,
    },
  },
  scrollbar: {
    el: null,
    hide: false,
    draggable: true,
  },
};

document.querySelectorAll('.general-swiper').forEach(function (element) {
  const isPostGridSlider = element.classList.contains(
    'block-post-grid__slider',
  );
  const isUpsellsSlider = element.classList.contains('upsells-swiper');
  const isProductSlider = element.classList.contains('block-products__slider');
  // Projecten-slider gebruikt dezelfde 3-kolommen config als post-grid
  const isProjectsSlider = element.classList.contains('block-projects__slider');
  const isImageSlider = element.classList.contains('block-slider__slider');
  const useThreeColumns =
    isPostGridSlider || isProductSlider || isProjectsSlider;
  const baseConfig = isUpsellsSlider
    ? upsellsSliderConfig
    : isImageSlider
      ? imageSliderConfig
      : useThreeColumns
        ? postGridSliderConfig
        : {
            grabCursor: true,
            slidesPerView: 1.15,
            spaceBetween: 20,
            watchOverflow: true,
            breakpoints: {
              768: {
                slidesPerView: 1.25,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 1.8,
                spaceBetween: 32,
              },
            },
            scrollbar: {
              el: null,
              hide: false,
            },
          };

  const config = {
    ...baseConfig,
    scrollbar: {
      ...baseConfig.scrollbar,
      el: element.querySelector('.swiper-scrollbar'),
    },
    on: {
      reachEnd: function () {
        element.classList.add('reached-end');
      },
      fromEdge() {
        element.classList.remove('reached-end');
      },
    },
  };

  new Swiper(element.querySelector('.swiper-container'), config);
});
